import loadable from "@loadable/component";
import SwitchTab from "../../components/Reusable/SwitchTab";
const StockValuationComponent = loadable(
  () => import("../../components/InventoryReport/StockValuationDetail")
);
const StockValuationDetail = () => {
  const tabs = [
    {
      id: "stock-valuation-normal",
      label: "Normal",
      href: "/accounting/stock-valuation-normal",
    },
    {
      id: "stock-valuation-group",
      label: "Grouped",
      href: "/accounting/stock-valuation-group",
    },
    {
      id: "stock-valuation-detail",
      label: "Detail",
      href: "/accounting/stock-valuation-detail",
    },
  ];
  return (
    <>
      <SwitchTab tabs={tabs} /> <StockValuationComponent />
    </>
  );
};

export default StockValuationDetail;
